// removed by extract-text-webpack-plugin
module.exports = {"transparencyGrid":"Sidebar-transparency-grid","logoPreview":"Sidebar-logo-preview","logoThumbnail":"Sidebar-logo-thumbnail","noBrandText":"Sidebar-no-brand-text","logoSelected":"Sidebar-logo-selected","metaBoxContainer":"Sidebar-meta-box-container","metaBoxDeleteBtn":"Sidebar-meta-box-delete-btn"};


//////////////////
// WEBPACK FOOTER
// ./src/Sidebar.css
// module id = 195
// module chunks = 0